module.exports = __webpack_public_path__ + "static/media/investment_focused.8dcf1c91.svg";